import "../../../components/welcomeScreen/welcomeWizard.scss";

import PropTypes from "prop-types";
import React from "react";

import Icon from "../../../components/interface/Icon";
import ModalCheckboxGrid from "../../../components/modal/ModalCheckboxGrid";
import ModalField from "../../../components/modal/ModalField";
import ModalGroup from "../../../components/modal/ModalGroup";
import ModalRow from "../../../components/modal/ModalRow";
import preprocessorQuery from "../../../utils/preprocessorQuery";

const isIos = preprocessorQuery.isIos();

const FinalPage = _props => {
  return [
    <ModalGroup label="Great!" key="content">
      <ModalRow minFieldWidth={true}>
        <ModalField>
          <ModalCheckboxGrid columns={1}>
            {isIos ? (
              <div className="welcomeWizardAttributeItem">
                <Icon icon="tick" />
                <div className="welcomeWizardAttributeItemLabel">
                  Your upgraded timeline will be saved in the same folder as your existing file.
                </div>
              </div>
            ) : null}
            <div className="welcomeWizardAttributeItem">
              <Icon icon="tick" />
              <div className="welcomeWizardAttributeItemLabel">
                Start with a clean slate, or import data to pre-populate your timeline
              </div>
            </div>
            <div className="welcomeWizardAttributeItem">
              <Icon icon="tick" />
              <div className="welcomeWizardAttributeItemLabel">
                Remember you can update your selections at any time via Settings
              </div>
            </div>
          </ModalCheckboxGrid>
        </ModalField>
        <ModalField>
          <ModalCheckboxGrid columns={1}>
            <div className="welcomeWizardAttributeItem">
              <Icon icon="tick" />
              <div className="welcomeWizardAttributeItemLabel">Check out the Getting Started tips in the Tutorial</div>
            </div>
            <div className="welcomeWizardAttributeItem">
              <Icon icon="tick" />
              <div className="welcomeWizardAttributeItemLabel">
                Advanced tutorials become available as you build your timeline
              </div>
            </div>
          </ModalCheckboxGrid>
        </ModalField>
      </ModalRow>
    </ModalGroup>
  ];
};

FinalPage.propTypes = {
  onBackClick: PropTypes.func.isRequired,
  onDoneClick: PropTypes.func.isRequired
};

export default FinalPage;
